
import api from "../../../api/api"


const  serialize = (obj) =>{
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
      console.log(str)
    return str.join("&");
}


const getLastPunch = () =>{
    return new Promise((resolve, reject)=>{
        api.get("ess/attendance/punch").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const getPunchList = (filter) =>{
    return new Promise((resolve, reject)=>{
        api.get("ess/attendance/punch-list?"+serialize(filter)).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const addPunch = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("ess/attendance/punch",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


/**
 * Calculates the distance between two points in meters using the Haversine formula
 */
const getDistanceInMeters = (officeLocation, systemLocation) => { //calculateProximity
    const R = 6371e3; // Earth's radius in meters
    
    officeLocation.lat = Number(officeLocation.lat);
    officeLocation.lng = Number(officeLocation.lng);

    console.log("Office Location",officeLocation);
    console.log("System Location",systemLocation);

    // Convert degrees to radians
    const φ1 = (officeLocation.lat * Math.PI) / 180;
    const φ2 = (systemLocation.lat * Math.PI) / 180;
    
    const Δφ = ((systemLocation.lat - officeLocation.lat) * Math.PI) / 180;
    const Δλ = ((systemLocation.lng - officeLocation.lng) * Math.PI) / 180;

    // Haversine formula logic
    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
                Math.cos(φ1) * Math.cos(φ2) *
                Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
                
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distance = R * c; // Distance in meters
    return Math.round(distance); // Returns distance rounded to the nearest meter
};

const essPunchServices = {
    getLastPunch,
    getPunchList,
    addPunch,
    getDistanceInMeters
}

export default essPunchServices;
